var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6b262;}.cls-2{fill:#d28a34;}.cls-3{fill:#eec590;}.cls-4{fill:#3ab3e1;}.cls-5,.cls-6{fill:none;stroke:#fff;stroke-width:4px;}.cls-5{stroke-miterlimit:10;}.cls-6{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "update-email-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_11",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-mail"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.34,76.57V196.08A17.32,17.32,0,0,0,17.66,213.4h225.1c9.57,0,16-7.76,16-17.32l.55-119.51L138.24,145.84c-5.35,3.07-11.34,3.7-16.68.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.14,208.53l-86-79.78-29.86,17.09c-5.35,3.07-11.34,3.7-16.68.61l-32.28-18.6h0L5.39,208.3a17.24,17.24,0,0,0,12.27,5.1h225.1A15.21,15.21,0,0,0,254.14,208.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.07,44.16H17.39A17.33,17.33,0,0,0,.07,61.79L.34,76.57l119.9,69.25c5.33,3.06,12.68,3.89,18,0L259.3,76.57l.09-15A17.32,17.32,0,0,0,242.07,44.16Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.84,
    cy: 202.04,
    r: 50.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.21,191.65s6.22-16.1,24.63-16.44,24.74,16.19,24.74,16.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "275.14 186.44 273.57 191.46 268.56 189.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.12,212.44s6.41,16.32,24.72,16.42,24.64-16.42,24.64-16.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "222.6 217.46 224.17 212.44 229.19 214.01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateEmailIcon);
export default __webpack_public_path__ + "static/media/update-email-icon.e9ea9a9e0e6fbb49425028be6b0064a4.svg";
export { ForwardRef as ReactComponent };